module.exports = __webpack_public_path__ + "img/4.a69eff01.webp";